var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition",class:{
    'cursor-pointer hover:border-primary-green-100 select-none': _vm.clickable,
    'border border-border-normal': _vm.border,
    'base-card': !_vm.border
  },on:{"click":function($event){_vm.clickable && _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }